// Vùng của cảng theo TblFreightRoute.PODRegion / TblPortData.Region (LOGI-data-dictionary.md · crm-rates-svc §2.3).
// LOGI lẫn hoa/thường và sai chính tả ("Midle East"); `logi` giữ đúng giá trị gốc để đối chiếu dữ liệu.
import { compactKey } from './text';

export const REGIONS = [
  { key: 'ASIA_EASTERN', logi: 'ASIA EASTERN', vi: 'Đông Á' },
  { key: 'ASIA_SOUTH_EASTERN', logi: 'ASIA SOUTH-EASTERN', vi: 'Đông Nam Á' },
  { key: 'ASIA_SOUTHERN', logi: 'ASIA SOUTHERN', vi: 'Nam Á' },
  { key: 'ASIA_WESTERN', logi: 'ASIA WESTERN', vi: 'Tây Á' },
  { key: 'MIDDLE_EAST', logi: 'Midle East', vi: 'Trung Đông' },
  { key: 'EUROPE_WESTERN', logi: 'EUROPE WESTERN', vi: 'Tây Âu' },
  { key: 'EUROPE_EASTERN', logi: 'EUROPE EASTERN', vi: 'Đông Âu' },
  { key: 'MEDITERRANEAN', logi: 'Mediterranean', vi: 'Địa Trung Hải' },
  { key: 'OCEANIA', logi: 'OCEANIA', vi: 'Châu Đại Dương' },
  { key: 'NORTHERN_AMERICA', logi: 'Northern America', vi: 'Bắc Mỹ' },
  { key: 'AMERICA_CENTRAL', logi: 'AMERICA CENTRAL', vi: 'Trung Mỹ' },
  { key: 'LATIN_AMERICA', logi: 'Latin America', vi: 'Mỹ Latinh' },
  { key: 'CARIBBEAN', logi: 'CARIBBEAN', vi: 'Caribe' },
  { key: 'NORTHERN_AFRICA', logi: 'Northern Africa', vi: 'Bắc Phi' },
  { key: 'WESTERN_AFRICA', logi: 'Western Africa', vi: 'Tây Phi' },
  { key: 'EASTERN_AFRICA', logi: 'Eastern Africa', vi: 'Đông Phi' },
  { key: 'MIDDLE_AFRICA', logi: 'Middle Africa', vi: 'Trung Phi' },
  { key: 'SOUTHERN_AFRICA', logi: 'Southern Africa', vi: 'Nam Phi' },
] as const;

export type RegionKey = (typeof REGIONS)[number]['key'];
export type Region = (typeof REGIONS)[number];

const BY_COMPACT = new Map<string, RegionKey>();
for (const r of REGIONS) {
  BY_COMPACT.set(compactKey(r.key), r.key);
  BY_COMPACT.set(compactKey(r.logi), r.key);
}
BY_COMPACT.set('MIDDLEEAST', 'MIDDLE_EAST');

/** Giá trị vùng LOGI (mọi kiểu viết) → khoá vùng; không nhận ra thì `null`. */
export function normalizeRegion(value: string | null | undefined): RegionKey | null {
  if (!value) return null;
  return BY_COMPACT.get(compactKey(value)) ?? null;
}

export function regionOf(key: RegionKey): Region {
  return REGIONS.find((r) => r.key === key)!;
}
